import * as React from "react";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "@/components/ui/react-select";

export type SparkSpreadFuturesContract = string;

interface SparkSpreadFuturesContractSelectProps {
  uniquePeriods: SparkSpreadFuturesContract[];
  selectedPeriods: SparkSpreadFuturesContract[];
  setSelectedPeriods: React.Dispatch<React.SetStateAction<SparkSpreadFuturesContract[]>>;
}

export function SparkSpreadFuturesContractSelect(props: SparkSpreadFuturesContractSelectProps) {
  const { t } = useTranslation();
  const options = props.uniquePeriods.map((period) => ({ value: period, label: period }));

  return (
    <MultiSelect
      isMulti
      options={options}
      value={options.filter((option) => props.selectedPeriods.includes(option.value as SparkSpreadFuturesContract))}
      onChange={(selectedOptions) => {
        const selectedValues = selectedOptions.map((option) => option.value as SparkSpreadFuturesContract);
        props.setSelectedPeriods(selectedValues);
      }}
      placeholder={t("Select futures contracts")}
      className="w-full"
    />
  );
}
